var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSwapHorizontalCircle = function SvgSwapHorizontalCircle(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m10 13-2 2m0 0 2 2m-2-2h8M8 9h8m0 0-2-2m2 2-2 2m4.364-5.364A9 9 0 1 1 5.636 18.364 9 9 0 0 1 18.364 5.636Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSwapHorizontalCircle);
export default ForwardRef;